import React, { useState } from 'react'
import { updateDeliveryStatus } from '../actions'
import { connect } from 'react-redux'

const options = ['no_event', 'too_big']
const translate = { 'no_event': 'Ej levererad till enhet', 'too_big': 'För stort gods' }

const SetStatusButton = ({ delivery, updateDeliveryStatus }) => {
    const [status, setSelect] = useState()

    if (status && status !== delivery.qsignReason && status.length > 1) {
        updateDeliveryStatus({ deliveryId: delivery._id, status })
    }

    return (
        <div>
            <select onChange={(e) => setSelect(e.target.value)} value={delivery.qsignReason?.toLowerCase()}>
                <option>&nbsp;</option>
                {options.map((o, i) => {
                    return (
                        <option key={i} value={o}>
                            {translate[o]}
                        </option>
                    )
                })}
            </select>
        </div>
    )
}

const mapProps = state => {
    return {}
}

const mapDispatch = (dispatch) => ({
    updateDeliveryStatus: (obj) => dispatch(updateDeliveryStatus(obj)),
})

export default connect(mapProps, mapDispatch)(SetStatusButton)